// Mock data for Lead Matrix Business Solutions

export const company = {
  name: "Lead Matrix Business Solutions",
  shortName: "Lead Matrix",
  tagline: "Talent. Growth. Careers. BPO. Innovation.",
  email: "info@lmbs.in",
  careerEmail: "career@lmbs.in",
  phone: "+91 90806 94478",
  locations: "Bangalore",
  address: "Bangalore, Karnataka, India",
  logo: "/logo.png",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Expertise", href: "#expertise" },
  { label: "Journey", href: "#journey" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const services = [
  {
    id: 1,
    title: "Recruitment & Talent Hiring",
    description: "End-to-end recruitment across IT, Non-IT, voice process, and industrial domains.",
    icon: "Users",
  },
  {
    id: 2,
    title: "Career & Fresher Services",
    description: "Support for fresh graduates with resume building, soft skills, and interview readiness.",
    icon: "GraduationCap",
  },
  {
    id: 3,
    title: "Training & Development",
    description: "Technical, HR, IELTS, languages, and banking logistics training tailored for students and job seekers.",
    icon: "BookOpen",
  },
  {
    id: 4,
    title: "BPO Solutions",
    description: "End-to-end BPO services including inbound & outbound call center, customer support, back-office, and voice/non-voice process outsourcing.",
    icon: "Headphones",
  },
];

export const bpoOfferings = [
  { id: "bpo-inbound", title: "Inbound Call Center", desc: "24/7 customer support, order taking, help desk, and technical assistance." },
  { id: "bpo-outbound", title: "Outbound Call Center", desc: "Lead generation, telemarketing, appointment setting, and market research." },
  { id: "bpo-back-office", title: "Back Office Support", desc: "Data entry, processing, document management, and administrative services." },
  { id: "bpo-voice", title: "Voice & Non-Voice Process", desc: "Multilingual voice support and non-voice chat/email process outsourcing." },
];

export const expertiseCards = [
  {
    id: "exp-hr",
    title: "HR Training Program",
    image: "https://images.unsplash.com/photo-1664382953481-141e97ad9825?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxIUiUyMHRyYWluaW5nfGVufDB8fHx8MTc4NTAwNDQ2OHww&ixlib=rb-4.1.0&q=85",
    tag: "HR",
  },
  {
    id: "exp-it",
    title: "IT Talent Acquisition",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxJVCUyMHJlY3J1aXRtZW50fGVufDB8fHx8MTc4NTAwNDQ2OXww&ixlib=rb-4.1.0&q=85",
    tag: "IT",
  },
  {
    id: "exp-training",
    title: "Corporate & Technical Training",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODQ4NjY2ODF8MA&ixlib=rb-4.1.0&q=85",
    tag: "Training",
  },
  {
    id: "exp-bpo",
    title: "BPO Solutions",
    image: "https://images.pexels.com/photos/7658369/pexels-photo-7658369.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "BPO",
  },
];

export const marqueeItems = [
  "HR Training for MBA Students",
  "IT Talent Acquisition Services",
  "BPO Solutions for Enterprises",
  "Corporate & Technical Training",
  "Data Analytics & Power BI Courses",
  "Resume Review & Career Support",
  "Job Placement Assistance",
];

export const stats = [
  { id: "stat-yrs", value: "12+", label: "Years Experience" },
  { id: "stat-courses", value: "80+", label: "Courses Offered" },
  { id: "stat-placement", value: "95%", label: "Placement Success Rate" },
  { id: "stat-clients", value: "500+", label: "Corporate Clients" },
];

export const journeySteps = [
  { id: "step-1", step: "01", title: "Consultation & Assessment", desc: "We understand your business goals and evaluate your talent requirements." },
  { id: "step-2", step: "02", title: "Training & Certification", desc: "Tailored HR, technical, and BPO training programs led by industry experts." },
  { id: "step-3", step: "03", title: "Talent Sourcing", desc: "Access to a vetted candidate pool across IT, Non-IT, and voice processes." },
  { id: "step-4", step: "04", title: "Interview & Selection", desc: "Mock interviews, ATS resume optimization, and screening support." },
  { id: "step-5", step: "05", title: "Placement & Onboarding", desc: "End-to-end placement support and post-hire onboarding assistance." },
];

export const testimonials = [
  {
    id: "tst-ramesh",
    name: "Ramesh Kumar",
    role: "HR Manager, IT Solutions Co.",
    text: "Lead Matrix's corporate training program transformed our recruitment process. Their team understood our needs and delivered practical, results-driven solutions that improved our hiring efficiency significantly.",
    avatar: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    rating: 5,
  },
  {
    id: "tst-aditi",
    name: "Aditi Rao",
    role: "MBA HR Graduate",
    text: "Lead Matrix's HR training gave me the skills and confidence to handle IT recruitment end-to-end. The mock interviews and ATS resume review were game-changers for my career.",
    avatar: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODUwMDQ0Njh8MA&ixlib=rb-4.1.0&q=85",
    rating: 5,
  },
  {
    id: "tst-priya",
    name: "Priya Sharma",
    role: "Operations Head, BPO Enterprises",
    text: "The BPO solutions from Lead Matrix have streamlined our customer support operations. Their voice and non-voice teams are exceptional, and the response times have improved by 40%.",
    avatar: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODUwMDQ0Njh8MA&ixlib=rb-4.1.0&q=85",
    rating: 5,
  },
];

export const heroStats = [
  { id: "hero-yrs", value: "12", suffix: "+", label: "Years Experience" },
  { id: "hero-courses", value: "80", suffix: "+", label: "Courses Offered" },
];

export const heroImage = "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODUwMDQ0Njh8MA&ixlib=rb-4.1.0&q=85";
export const aboutImage = "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3ODUwMDQ0Njh8MA&ixlib=rb-4.1.0&q=85";
